import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Typography, CircularProgress } from '@material-ui/core';
import ExpansionPanel from '../common/ExpansionPanel';
import MetricGrowthPanel from './MetricGrowthPanel';
import Error from '../common/Error';

const styles = theme => ({
  root: {
    maxWidth: 700,
    marginTop: theme.spacing(3),
    overflowX: 'auto',
    margin: 'auto',
    padding: '5px'
  },
  table: {
    minWidth: 700
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    minWidth: 300
  }
});

function MetricGrowth(props) {
  const { classes } = props;
  const YEARS_QUERY = gql`
    query getYears {
      growingFastestPerYear {
        year
        value
        metric
      }
    }
  `;

  const renderYears = ({ loading, error, data }) => {
    if (loading) return <CircularProgress />;
    if (error) return <Error />;

    return (
      <>
        <ExpansionPanel
          panels={data.growingFastestPerYear.map(row => ({
            heading: row.year,
            secondaryHeading: row.metric,
            details: <MetricGrowthPanel year={row.year} />
          }))}
        />
      </>
    );
  };

  return (
    <Paper className={classes.root}>
      <Typography variant='h3'>Fastest Growth</Typography>
      <Typography color='textSecondary' gutterBottom>
        The fastest growing metrics in each year, in the United States.
      </Typography>
      {renderYears(useQuery(YEARS_QUERY))}
    </Paper>
  );
}

export default withStyles(styles)(MetricGrowth);
